var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/gdpr-banner.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Banner, Button, HStack, Stack, Text } from 'soapbox/components/ui';
import { useAppSelector, useSoapboxConfig } from 'soapbox/hooks';
const acceptedGdpr = !!localStorage.getItem('soapbox:gdpr');
/** Displays a cookie consent banner. */

const GdprBanner = () => {
  /** Track whether the banner has already been displayed once. */
  const [shown, setShown] = useState(acceptedGdpr);
  const [slideout, setSlideout] = useState(false);
  const soapbox = useSoapboxConfig();
  const isLoggedIn = useAppSelector(state => !!state.me);
  const siteTitle = useAppSelector(state => state.instance.title);

  const handleAccept = () => {
    localStorage.setItem('soapbox:gdpr', 'true');
    setSlideout(true);
    setTimeout(() => setShown(true), 200);
  };

  const showBanner = soapbox.gdpr && !isLoggedIn && !shown;

  if (!showBanner) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Banner, {
    theme: "opaque",
    className: classNames('transition-transform', {
      'translate-y-full': slideout
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col space-y-4 lg:space-y-0 lg:space-x-4 lg:flex-row lg:items-center lg:justify-between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xl",
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gdpr.title",
    defaultMessage: "{siteTitle} uses cookies",
    values: {
      siteTitle
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    className: "opacity-60",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gdpr.message",
    defaultMessage: "{siteTitle} uses session cookies, which are essential to the website's functioning.",
    values: {
      siteTitle
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    alignItems: "center",
    className: "flex-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 9
    }
  }, soapbox.gdprUrl && /*#__PURE__*/React.createElement("a", {
    href: soapbox.gdprUrl,
    tabIndex: -1,
    className: "inline-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gdpr.learn_more",
    defaultMessage: "Learn more",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Button, {
    theme: "accent",
    onClick: handleAccept,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gdpr.accept",
    defaultMessage: "Accept",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  })))));
};

export default GdprBanner;